import { useState } from "react";
import { Brain, Check, Layers, MessageCircleQuestion, Sparkles, Volume2, X } from "lucide-react";

/**
 * InSnip Pro: the positioning surface for the paid tier. It is deliberately honest, payments are
 * not wired yet (that needs the store + billing accounts), so instead of a fake checkout this
 * captures founding-member interest and frames Pro around the knowledge companion: go deeper,
 * remember more, make it yours. Self-contained; the parent records interest via onInterest.
 */
const PRO_BENEFITS: { Icon: typeof Brain; title: string; copy: string }[] = [
  { Icon: MessageCircleQuestion, title: "Ask without limits", copy: "Question any card and go as deep as you want, no daily cap." },
  { Icon: Sparkles, title: "Deep dives", copy: "Longer, structured explainers on the stories you care about most." },
  { Icon: Layers, title: "Unlimited library + Recall", copy: "Keep every idea and let spaced recall make it stick." },
  { Icon: Brain, title: "Custom topic feeds", copy: "Tune InSnip to exactly the subjects you're learning." },
  { Icon: Volume2, title: "Audio + ad-free", copy: "Listen to your drop, with no sponsored cards, ever." },
];

export function ProModal(props: { onInterest: () => void; onClose: () => void }) {
  const [interested, setInterested] = useState(false);

  function express(): void {
    setInterested(true);
    props.onInterest();
  }

  return (
    <section
      className="insight-modal"
      role="dialog"
      aria-modal="true"
      aria-label="InSnip Pro"
      onClick={props.onClose}
    >
      <div className="pro-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="quiz-close icon-button ghost"
          onClick={props.onClose}
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <span className="pro-badge">InSnip Pro</span>
        <h2 className="pro-title">Go deeper. Remember more.</h2>
        <p className="pro-sub">
          The free feed keeps you sharp in minutes a day. Pro is for when you want to truly learn,
          not just keep up.
        </p>

        <ul className="pro-benefits">
          {PRO_BENEFITS.map(({ Icon, title, copy }) => (
            <li key={title}>
              <span className="pro-benefit-icon" aria-hidden="true"><Icon size={16} /></span>
              <span>
                <strong>{title}</strong>
                {copy}
              </span>
            </li>
          ))}
        </ul>

        {interested ? (
          <div className="pro-confirm" role="status">
            <span className="pro-confirm-icon" aria-hidden="true"><Check size={18} /></span>
            <p>You're on the founding-member list. We'll let you know the moment Pro opens, at a founder's price.</p>
            <button type="button" className="ghost-action" onClick={props.onClose}>Done</button>
          </div>
        ) : (
          <div className="pro-cta-wrap">
            <button type="button" className="pro-cta" onClick={express}>
              Become a founding member
            </button>
            <p className="pro-note">
              Pro isn't live yet. Join the list and you'll be first in, at the lowest price it will
              ever be.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
